// Keep these rules in sync with the API contactValidators.js schema.
export const CONTACT_FIELD_LIMITS = Object.freeze({
  companyName: 100, email: 200, phone: 50, productCode: 50, subject: 100, message: 2000,
});

export function isValidContactEmail(email) {
  return /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+.-]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z]{2,}$/.test(
    String(email || '').trim(),
  );
}

export function formatContactIssue(issue, t) {
  const field = issue?.path?.[0];
  const labelKey = field === 'productCode' ? 'product' : field;
  if (!Object.prototype.hasOwnProperty.call(CONTACT_FIELD_LIMITS, field) && field !== 'inquiryType') {
    return t('contact.submitFailed');
  }
  const fieldLabel = t('contact.fields.' + labelKey + '.label');
  if (issue.code === 'too_big') {
    return t('contact.validation.tooLong', {
      field: fieldLabel, maximum: issue.maximum,
      defaultValue: '{{field}} must be {{maximum}} characters or fewer.',
    });
  }
  if (field === 'email') return t('contact.validation.invalidEmail');
  return t('contact.validation.invalidField', {
    field: fieldLabel,
    defaultValue: 'Please check {{field}} and try again.',
  });
}

export function getContactLengthError(form, t) {
  for (const [field, maximum] of Object.entries(CONTACT_FIELD_LIMITS)) {
    if (String(form[field] || '').trim().length > maximum) {
      return formatContactIssue({ path: [field], code: 'too_big', maximum }, t);
    }
  }
  return '';
}
